import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from 'vue';
    import { useQuery } from '@tanstack/vue-query';
    import { useI18n } from 'vue-i18n';
    import axios from 'axios';
    import { UserCog } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import EditUserCompany from '@/components/user-companies/EditUserCompany.vue';
    import type { UserCompany } from '@/types';
    import { triggerDashboardTableRefetch } from '@/composables/dashboardTableRefresh';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardAssignedActions',
  props: {
    companyId: {},
    refreshDashboard: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();
    const { hasPermission } = usePermissions();

    const canEdit = computed(() => hasPermission(Permission.COMPANIES_UPDATE));

    const editRequested = ref(false);
    const editOpen = ref(false);

    const { data: userCompany } = useQuery({
        queryKey: ['dashboard-user-company', props.companyId],
        queryFn: async (): Promise<UserCompany> => {
            const { data } = await axios.get(route('v2.user-companies.get', props.companyId));
            return data;
        },
        enabled: editRequested,
        gcTime: 0,
    });

    const openEdit = () => {
        if (userCompany.value) {
            editOpen.value = true;
            return;
        }

        editRequested.value = true;
    };

    watch(userCompany, (value) => {
        if (value && editRequested.value) {
            editOpen.value = true;
        }
    });

    // Capture the value now so the callback works even after this component
    // is unmounted by the Inertia page remount that follows a modal save.
    const shouldRefreshDashboard = props.refreshDashboard === true;

    const refreshDashboardTable = () => {
        if (!shouldRefreshDashboard) {
            return;
        }

        triggerDashboardTableRefetch({ forceHydration: true });
    };

return (_ctx: any,_cache: any) => {
  return (canEdit.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flex w-6 shrink-0 items-center justify-end",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_unref(Button), {
          variant: "ghost_primary",
          size: "icon_sm",
          class: "size-6 text-muted-foreground",
          title: _unref(t)('companies.user_companies_edit_title'),
          onClick: openEdit
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UserCog), { class: "size-3.5" })
          ]),
          _: 1
        }, 8, ["title"]),
        (_unref(userCompany))
          ? (_openBlock(), _createBlock(EditUserCompany, {
              key: 0,
              "user-company": _unref(userCompany),
              open: editOpen.value,
              "after-success": refreshDashboardTable,
              "hide-trigger": "",
              "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (editOpen.value = $event))
            }, null, 8, ["user-company", "open"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})